import { AdaLocalizedDatePipe, IsEmptyInputPipe } from '@adaptiva/core/common';
import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { SummarizeModule } from '@adaptiva/core/summary';
import { EJavaClassNames } from '@adaptiva/data-service';
import { SoftwareProduct } from '@adaptiva/metadata/common';
import { CpeWebViewTableComponentModule, CveDisplayAnchorComponentModule } from '@adaptiva/metadata/widgets';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { ListBuilderComponentModule } from '@adaptiva/widgets/list-builder';
import { ObjectListModule } from '@adaptiva/widgets/object-list';
import { ObjectListBuilderComponentModule } from '@adaptiva/widgets/object-list-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EndOfLifeProductEditorActionOverlayComponent } from './end-of-life-product-editor-action-overlay.component';

const _pipes = [
	AdaLocalizedDatePipe,
	IsEmptyInputPipe
];

const _widgets = [
	AlertComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	CpeWebViewTableComponentModule,
	CveDisplayAnchorComponentModule,
	InputComponentModule,
	LabelComponentModule,
	ListBuilderComponentModule,
	ObjectListBuilderComponentModule,
	ObjectListModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		_pipes,
		_widgets,
		CommonModule,
		DynamicComponentLoaderModule.forChild(EndOfLifeProductEditorActionOverlayComponent),
		SummarizeModule.register([
			[EJavaClassNames.SoftwareProduct, SoftwareProduct]
		])
	],
	declarations: [EndOfLifeProductEditorActionOverlayComponent],
	exports: [EndOfLifeProductEditorActionOverlayComponent]
})
export class EndOfLifeProductEditorActionOverlayComponentModule {

}
